<template>
  <div class="recent-viewed-page">
    <div class="page-header">
      <h1>最近浏览</h1>
      <el-button type="text" @click="$router.push('/')">
        <i class="el-icon-arrow-left"></i> 返回主页
      </el-button>
    </div>

    <el-card class="content-card">
      <div class="empty-state" v-if="recentFiles.length === 0">
        <i class="el-icon-eye"></i>
        <p>暂无浏览记录</p>
        <el-button type="primary" @click="$router.push('/file/my-files')">
          去浏览文件
        </el-button>
      </div>

      <!-- 后续可添加最近浏览文件表格 -->
      <el-table v-else :data="recentFiles" border>
        <el-table-column prop="fileName" label="文件名" width="300"></el-table-column>
        <el-table-column prop="fileSize" label="文件大小" width="120">
          <template #default="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
        </el-table-column>
        <el-table-column prop="viewTime" label="浏览时间" width="200"></el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button type="text" icon="el-icon-download" size="small" @click="downloadFile(scope.row.id)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { downloadFile as downloadFromCdn } from '@/api/file'
import { formatFileSize } from '@/utils/format'

export default {
  name: 'RecentViewed',
  data() {
    return {
      // 示例数据，后续可通过接口获取
      recentFiles: []
    }
  },
  created() {
    // 实际项目中通过接口加载最近浏览记录
    // this.loadRecentFiles()
  },
  methods: {
    formatFileSize,
    // 示例：加载最近浏览记录
    loadRecentFiles() {
      // 调用接口获取数据
      // this.recentFiles = 接口返回的最近浏览列表
    },
    // 下载文件
    async downloadFile(fileId) {
      try { await downloadFromCdn(fileId) }
      catch (error) { this.$message.error(error.message || '下载失败') }
    }
  }
}
</script>

<style scoped>
.recent-viewed-page {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.content-card {
  min-height: 400px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #666;
}

.empty-state .el-icon-eye {
  font-size: 60px;
  margin-bottom: 20px;
  color: #ccc;
}
</style>
